'use client';
import Hamburger from 'hamburger-react';
import React from 'react';
import { useState } from 'react';
import './Hamburger.css';
import '../../root.css';
import { Link } from 'react-router-dom';
import MenuSocials from '../Common/MenuSocials';
import Ig from '../../Assets/Icons/Ig.svg';
import Tw from '../../Assets/Icons/Tw.svg';
import Yt from '../../Assets/Icons/Yt.svg';
import Fb from '../../Assets/Icons/Fb.svg';


const HamburgerComp = () => {

    const [open,setOpen] = useState(false);

    return ( 
        <>
        <Hamburger color='#D9E3DF' toggled={open} toggle={setOpen}/>
        {open && <div className="burgerMenu">
                <header>
                    <nav>
                        <ul>
                            <Link className='headerLogo' to="/">AXIS</Link>
                            <Hamburger color='#D9E3DF' toggled={open} toggle={setOpen}/>
                        </ul>
                    </nav>
                </header>
                <div className="burgerMenuCont">
                    <div className="burgerMenuLeft">
                        <Link className='burgerMenuItem' to="/">Home</Link>
                        <Link className='burgerMenuItem' to="/Catalogue">Listings</Link>
                        <Link className='burgerMenuItem' to="/Details">Details</Link>
                    </div>
                    <div className="burgerMenuRight">
                        <h1>Curated Spaces. <br></br> Defined Living.</h1>
                        <div className="burgerCol gap-24">
                            <h6>MAIN OFFICE</h6>
                            <div className="burgerCol gap-20">
                                <h5>345 Realty Street Tower 5, 9th floor</h5>
                                <h5>+123 456 7890</h5>
                            </div>
                        </div>
                        <div className="burgerCol gap-20">
                            <h6>© 2026 Axis Realty. All rights reserved.</h6>
                            <div className="socialsBurger">
                                <MenuSocials menuSocial={Ig} menuSocialAlt='Instagram logo' />
                                <MenuSocials menuSocial={Tw} menuSocialAlt='Twitter logo' />
                                <MenuSocials menuSocial={Yt} menuSocialAlt='Youtube logo' />
                                <MenuSocials menuSocial={Fb} menuSocialAlt='Facebook logo' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
     );
}
 
export default HamburgerComp;